import * as React from 'react'
import { ApolloError } from '@apollo/client'
import styled from 'styled-components'

type Props = {
  children: ApolloError
}

const Component: React.FC<Props> = ({ children: error }) => {
  if (error.graphQLErrors.length > 0) {
    const messages = error.graphQLErrors.map(e => {
      if (e.extensions.code === 'UNAUTHENTICATION')
        return '認証に失敗しました。'

      return e.message
    })

    return <Error>{messages.join('\n')}</Error>
  }

  if (error.networkError)
    return <Error>ネットワークエラーが発生しました。</Error>

  return <Error>{error.message}</Error>
}

const Error = styled.p`
  white-space: pre-wrap;
`

export default Component
